export const Show = ({ children, when: condition, fallback = null }) =>
  condition ? children : fallback
